

// BlogDetails.jsx
import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Calendar, BookOpen, Share2 } from "lucide-react";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import Footer from "../Header & Footer/kfooter"
import FacebookIcon from "../Images/Konn3ct Images/facebook-02.png";
import TwitterIcon from "../Images/Konn3ct Images/new-twitter.png";
import LinkedInIcon from "../Images/Konn3ct Images/linkedin-01.png";
import InstagramIcon from "../Images/Konn3ct Images/instagram.png";
import blogPosts from "./KBlogs"; // ← Same data

const socialLinks = [
  { icon: FacebookIcon, url: "https://facebook.com/konn3ctapp" },
  { icon: TwitterIcon, url: "https://x.com/konn3ctapp" },
  { icon: LinkedInIcon, url: "https://linkedin.com/in/konnectng" },
  { icon: InstagramIcon, url: "https://www.instagram.com/konn3ctng" },
];

const BlogDetails = () => {
  const { id } = useParams();
  const post = blogPosts.find((p) => p.id === parseInt(id));

  if (!post) {
    return (
      <div className="text-center py-32 text-2xl text-gray-500">
        Blog post not found
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 overflow-hidden pt-[64px] sm:pt-[80px] md:pt-[100px]">
      <Konn3ctHeader />

      <article className="max-w-4xl mx-auto px-6 py-4 lg:py-6">
        {/* Back Button */}
        <Link
          to="/BlogPage"
          className="inline-flex items-center gap-2 text-[#1A4699] hover:underline mb-4 text-lg font-medium"
        >
          <ArrowLeft className="w-5 h-5" /> Back to Blog
        </Link>

        {/* Hero Image */}
        <div className="rounded-2xl overflow-hidden shadow-2xl mb-4">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-96 object-cover"
          />
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight">
          {post.title}
        </h1>

        {/* Meta */}
        <div className="flex flex-wrap items-center gap-6 text-gray-600 mb-4">
          <div className="flex items-center gap-2 text-sm">
            <Calendar className="w-5 h-5" /> {post.date}
          </div>
          <div className="flex items-center gap-2 text-sm">
            <BookOpen className="w-5 h-5" /> {post.readTime}
          </div>
          <span className="px-4 py-2 bg-blue-50 text-[#1A4699] rounded-full text-sm font-medium">
            {post.category}
          </span>
        </div>

        {/* Author */}

        {/* <div className="flex items-center gap-5 py-2 border-y border-gray-200 mb-12">
          <div className="w-10 h-10 bg-blue-300 rounded-full border-2 border-dashed border-gray-500" />
          <div>
            <p className="font-bold text-gray-900 text-lg">{post.author}</p>
            <p className="text-sm text-gray-500">{post.authorRole}</p>
          </div>
        </div> */}

        {/* Author Section – First letters of name */}
        <div className="flex items-center gap-5 py-2 border-y border-gray-200 mb-12">
          {/* Avatar with initials */}
          <div className="w-16 h-16 bg-gradient-to-br from-[#1A4699] to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-2xl shadow-lg">
            {post.author
              .split(" ")
              .map((name) => name[0].toUpperCase())
              .join("")
              .slice(0, 2)}
          </div>

          {/* Author Info */}
          <div>
            <p className="font-bold text-gray-900 text-lg">{post.author}</p>
            <p className="text-sm text-gray-500">{post.authorRole}</p>
          </div>
        </div>

        {/* Full Blog Content - Perfect spacing */}
        <div className="prose prose-lg max-w-none text-gray-700 leading-8">
          {post.content}
        </div>

        {/* Share */}
        <div className="mt-16 pt-10 border-t border-gray-200">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            <p className="flex items-center gap-3 text-gray-600 font-medium">
              <Share2 className="w-5 h-5" /> Share this article
            </p>

            <div className="flex gap-3">
              {socialLinks.map((item, index) => (
                <a
                  key={index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-3 bg-blue-800 rounded-xl inline-flex items-center justify-center"
                >
                  <img src={item.icon} alt="social icon" className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default BlogDetails;
